/**
 * Draw Demand Notice detail values in bold without changing label metrics.
 * Call with x already computed while font is still normal
 * (argument evaluation happens before this sets bold).
 */
export const drawDnDetailValue = (doc, text, x, y, options) => {
  if (!doc) return;
  doc.setFont("helvetica", "bold");
  doc.text(String(text ?? "-"), x, y, options);
  doc.setFont("helvetica", "normal");
};

/** Bold Due Date / Extended Due Date lines on Demand Notice PDFs. */
export const drawDnDueDate = (doc, text, x, y, options) => {
  drawDnDetailValue(doc, text, x, y, options);
};
